import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

var root = $.from_html(`<div class="volume-picker svelte-3dp89q7xgyr53"><button class="stepper svelte-3dp89q7xgyr53" aria-label="Decrease volume"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" class="svelte-3dp89q7xgyr53"><path d="M5 12h14"></path></svg></button> <div class="volume-display svelte-3dp89q7xgyr53"><input type="number" class="volume-input svelte-3dp89q7xgyr53"/> <span class="volume-unit svelte-3dp89q7xgyr53"> </span></div> <button class="stepper svelte-3dp89q7xgyr53" aria-label="Increase volume"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" class="svelte-3dp89q7xgyr53"><path d="M12 5v14M5 12h14"></path></svg></button></div>`);

function VolumePicker($$anchor, $$props) {
	$.push($$props, true);

	let unit = $.prop($$props, 'unit', 3, 'mL'),
		step = $.prop($$props, 'step', 3, 5),
		min = $.prop($$props, 'min', 3, 0),
		max = $.prop($$props, 'max', 3, 500);

	function increment() {
		const next = Math.min($$props.value + step(), max());

		$$props.onchange(next);
	}

	function decrement() {
		const next = Math.max($$props.value - step(), min());

		$$props.onchange(next);
	}

	function handleInput(e) {
		const target = e.target;
		const parsed = parseFloat(target.value) || 0;

		$$props.onchange(Math.max(min(), Math.min(parsed, max())));
	}

	var div = root();
	var button = $.child(div);
	var div_1 = $.sibling(button, 2);
	var input = $.child(div_1);

	$.remove_input_defaults(input);

	var span = $.sibling(input, 2);
	var text = $.child(span, true);

	$.reset(span);
	$.reset(div_1);

	var button_1 = $.sibling(div_1, 2);

	$.reset(div);

	$.template_effect(() => {
		button.disabled = $$props.value <= min();
		$.set_value(input, $$props.value);
		$.set_attribute(input, 'min', min());
		$.set_attribute(input, 'max', max());
		$.set_text(text, unit());
		button_1.disabled = $$props.value >= max();
	});

	$.delegated('click', button, decrement);
	$.delegated('input', input, handleInput);
	$.delegated('click', button_1, increment);
	$.append($$anchor, div);
	$.pop();
}

if (import.meta.hot) {
	VolumePicker = $.hmr(VolumePicker);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-3dp89q7xgyr53');
		VolumePicker[$.HMR].update(module.default);
	});
}

export default VolumePicker;

$.delegate(['click', 'input']);
import "bun-svelte:VolumePicker.svelte-1ybi7pzufptx9-style.css";